// Ported from vlookup-dramatic/app/about/milestone-rail.tsx by scripts/revamp/port-design.js
import React, { useRef } from "react";
import { ArrowLeft, ArrowRight } from "../../lib/icons";
/**
 * Compressed horizontal timeline: one scroll-snap rail of milestone cards
 * with big faint serif year numerals — minimal vertical footprint.
 */
export function MilestoneRail({ items }) {
    const railRef = useRef(null);
    const nudge = (dir) => {
        const rail = railRef.current;
        if (!rail)
            return;
        const card = rail.querySelector("li");
        const step = card ? card.getBoundingClientRect().width : 320;
        rail.scrollBy({ left: dir * step, behavior: "smooth" });
    };
    return (<div className="relative">
      {/* rail controls */}
      <div className="mb-7 flex items-center justify-between gap-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-brand-navy/40">
          2021 — 2026 · Scroll the journey
        </p>
        <div className="flex gap-2">
          <button type="button" aria-label="Previous milestones" onClick={() => nudge(-1)} className="flex size-10 items-center justify-center rounded-full border border-brand-navy/15 text-brand-navy transition-colors hover:bg-brand-navy hover:text-cream">
            <ArrowLeft className="size-4"/>
          </button>
          <button type="button" aria-label="Next milestones" onClick={() => nudge(1)} className="flex size-10 items-center justify-center rounded-full border border-brand-navy/15 text-brand-navy transition-colors hover:bg-brand-navy hover:text-cream">
            <ArrowRight className="size-4"/>
          </button>
        </div>
      </div>

      {/* QA row 67: the "more to scroll" fade used to cover the whole component
          incl. the Next arrow, which then read as disabled — keep it on the
          rail only. */}
      <div className="relative">
      <ol ref={railRef} aria-label="vLookUp milestones, 2021 to 2026" className="flex snap-x snap-mandatory overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.map((m, i) => {
            const last = i === items.length - 1;
            return (<li key={m.year} className="relative w-[78vw] max-w-[330px] shrink-0 snap-start border-t-2 border-brand-navy/10 pr-10 pt-8 sm:w-[330px]">
              {/* dot on the shared rail line */}
              <span aria-hidden className={`absolute -top-[7px] left-0 size-3 rounded-full bg-brand-red ${last ? "ring-4 ring-brand-red/20" : ""}`}/>
              <div aria-hidden className={`font-display text-7xl font-semibold leading-[0.85] md:text-8xl ${last ? "text-brand-red/15" : "text-brand-navy/10"}`}>
                {m.year}
              </div>
              <h3 className="relative -mt-6 font-display text-xl font-semibold text-heading md:-mt-7 md:text-[1.35rem]">
                <span className="sr-only">{m.year} — </span>
                {m.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {m.desc}
              </p>
            </li>);
        })}
      </ol>

      {/* right edge fade hints there's more to scroll */}
      <div aria-hidden className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background to-transparent"/>
      </div>
    </div>);
}
